import React, { useMemo, useEffect, useState, useRef } from "react";
import { Formik } from "formik";
import { useCouponContext } from "./CouponDataContext";
import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";
const prepareFilter = (values) => {
  const {
    idFilter,
    discountTypeFilter,
    batchTypeFilter,
    dateFilter,
    showFilter,
    activeFilter,
  } = values;
  const filter = {};
  // Filter by program
  filter.id = idFilter !== "" ? idFilter : "";
  filter.discount_type_id = discountTypeFilter !== "" ? discountTypeFilter : "";
  filter.batch_type = batchTypeFilter !== "" ? batchTypeFilter : "";
  filter.date = dateFilter !== "" ? dateFilter : "";
  filter.showing = showFilter !== "" ? showFilter : "";
  filter.active_id = activeFilter !== "" ? activeFilter : "";

  // Filter by all fields
  //   filter.days = searchText;
  //   if (searchText) {
  //     filter.start_time = searchText;
  //     filter.end_time = searchText;
  //     filter.instructor = searchText;
  //   }

  return filter;
};

export function CouponFilter({ filterData, origData, loading }) {
  const formRef = useRef();
  const DROPDOWN_TYPE = useCouponContext().TYPES;
  const [dataLoaded, setDataLoaded] = useState(false);
  const [showMoreFilters, setShowMoreFilters] = useState(false);
  const context = useCouponContext();
  const applyFilter = (values) => {
    //apply filter here
    filterData(prepareFilter(values));
  };
  const useStyles = makeStyles({
    btnCircleSm: {
      width: "30px",
            height: "30px",
            padding: "0px 7px",
            margin: "2px 1px 1px 1px",
            borderRadius: "15px",
            fontSize: "4px",
            textAlign: "center",
    },
  });
  const classes = useStyles();

  useEffect(() => {
    const initialValues = {
      idFilter: "",
      discountTypeFilter: "",
      dateFilter: "",
      batchTypeFilter: "",
      showFilter: "",
      activeFilter: "1",
    };
    applyFilter(initialValues);
  }, [origData]);

  //fetching classes for a branch
  useEffect(() => {
    formRef.current.click();
  }, [context.refetch, loading]);

  return (
    <>
      <Formik
        initialValues={{
          idFilter: "",
          discountTypeFilter: "",
          dateFilter: "",
          batchTypeFilter: "",
          showFilter: "",
          activeFilter: "1",
        }}
        onSubmit={(values) => {
          applyFilter(values);
        }}
      >
        {({
          values,
          handleSubmit,
          handleBlur,
          handleChange,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit} className="form form-label-right">
            <div className="form-group row">
            <div className="col-lg-2">
                <input
                  className="form-control"
                  placeholder="ID"
                  name="idFilter"
                  onBlur={handleBlur}
                  onChange={(e) => {
                    setFieldValue("idFilter", e.target.value);
                    handleSubmit();
                  }}
                  value={values.idFilter}
                ></input>
                <small className="form-text text-muted">
                  <b>Filter</b> by ID
                </small>
              </div>
              <div className="col-lg-2">
                <select
                  className="form-control"
                  placeholder="Filter by Status"
                  name="activeFilter"
                  onBlur={handleBlur}
                  onChange={(e) => {
                    setFieldValue("activeFilter", e.target.value);
                    handleSubmit();
                  }}
                  value={values.activeFilter}
                >
                  <option value="">All</option>

                  {DROPDOWN_TYPE.ACTIVE &&
                    DROPDOWN_TYPE.ACTIVE.map((a) => (
                      <option key={a.id} value={a.id}>
                        {a.value}
                      </option>
                    ))}
                </select>
                <small className="form-text text-muted">
                  <b>Filter</b> by Status
                </small>
              </div>
              
              <div className="col-lg-2">
                <select
                  className="form-control"
                  placeholder="Filter by Availability for Website"
                  name="showFilter"
                  onBlur={handleBlur}
                  onChange={(e) => {
                    setFieldValue("showFilter", e.target.value);
                    handleSubmit();
                  }}
                  value={values.showFilter}
                >
                  <option value="">All</option>
                  {DROPDOWN_TYPE.SHOWING &&
                    DROPDOWN_TYPE.SHOWING.map((a) => (
                      <option key={a.id} value={a.id}>
                        {a.value}
                      </option>
                    ))}
                </select>
                <small className="form-text text-muted">
                  <b>Filter</b> by Availability for Website
                </small>
              </div>
              
              <div className="col-lg-2">
                <select
                  className="form-control"
                  placeholder="Filter by Coupon Type"
                  name="discountTypeFilter"
                  onBlur={handleBlur}
                  onChange={(e) => {
                    setFieldValue("discountTypeFilter", e.target.value);
                    handleSubmit();
                  }}
                  value={values.discountTypeFilter}
                >
                  <option value="">All</option>
                  {DROPDOWN_TYPE.DISCOUNT_TYPE &&
                    DROPDOWN_TYPE.DISCOUNT_TYPE.map((a) => (
                      <option key={a.id} value={a.id}>
                        {typeof a.value === "string"
                          ? a.value.charAt(0).toUpperCase() + a.value.slice(1)
                          : a.value}
                      </option>
                    ))}
                </select>
                <small className="form-text text-muted">
                  <b>Filter</b> by Coupon Type
                </small>
              </div>
              <div className="col-lg-3">
                <select
                  className="form-control"
                  placeholder="Filter by Batch Type"
                  name="batchTypeFilter"
                  onBlur={handleBlur}
                  onChange={(e) => {
                    setFieldValue("batchTypeFilter", e.target.value);
                    handleSubmit();
                  }}
                  value={values.batchTypeFilter}
                >
                  <option value="">All</option>
                  {DROPDOWN_TYPE.BATCH_TYPE &&
                    DROPDOWN_TYPE.BATCH_TYPE.map((a) => (
                      <option key={a.id} value={a.id}>
                        {typeof a.value === "string"
                          ? a.value.charAt(0).toUpperCase() + a.value.slice(1)
                          : a.value}
                      </option>
                    ))}
                </select>
                <small className="form-text text-muted">
                  <b>Filter</b> by Batch Type
                </small>
              </div>
              <button
                type={"submit"}
                ref={formRef}
                style={{ display: "none" }}
                onClick={handleSubmit}
              />
              {/* <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="searchText"
                  placeholder="Search"
                  onBlur={handleBlur}
                  value={values.searchText}
                  onChange={(e) => {
                    setFieldValue("searchText", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  <b>Search</b> in all fields
                </small>
              </div> */}
               <button className={`btn btn-sm btn-circle btn-light ${classes.btnCircleSm}`} onClick={(e) => (setShowMoreFilters(!showMoreFilters))}><span className="svg-icon svg-icon-md svg-icon-danger">
              <i className={`fa text-${showMoreFilters ? `secondary fa-minus`: `primary fa-plus`}`}></i>
                          </span>
              </button>
            </div>
            {showMoreFilters && <div className="form-group row">
            
              <div className="col-lg-3">
                <input
                  type="date"
                  className={`form-control`}
                  placeholder="Filter by Date"
                  name="dateFilter"
                  onBlur={handleBlur}
                  onChange={(e) => {
                    setFieldValue("dateFilter", e.target.value);
                    handleSubmit();
                  }}
                  value={values.dateFilter}
                />
                <small className="form-text text-muted">
                  <b>Filter</b> by Date
                </small>
              </div>
                </div>
                }
          </form>
        )}
      </Formik>
    </>
  );
}
